import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { Option, WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { createOption } from '@mews-commander/ui';
import { useResourceCategoriesQuery } from '@mews-commander/legacy-entities/src/queries/resources';

export const useResourceCategoryOptions = ({ enterpriseId, serviceId }: WithServiceId & WithEnterpriseId) => {
    const { data, ...rest } = useResourceCategoriesQuery({ enterpriseId, serviceId });
    const options = pipe(
        data,
        option.fromNullable,
        option.map(array.map(({ id, name }) => createOption({ value: id, label: name }))),
        option.getOrElse<Option[]>(() => [])
    );

    return { data: options, ...rest };
};
